import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { laboratoryClient } from '../utils/laboratoryClient';
import { jsx as _jsx } from "react/jsx-runtime";
const ExperimentContext = /*#__PURE__*/createContext(null);
export const ExperimentProvider = ({
  children
}) => {
  const [treatments, setTreatments] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [eligibleTreatments, setEligibleTreatments] = useState([]);
  useEffect(() => {
    laboratoryClient.resolve(resolved => {
      setTreatments(resolved);
      setIsLoading(false);
    });
  }, []);
  const registerEligibility = useCallback(treatment => {
    setEligibleTreatments(prev => {
      const withoutCurrent = prev.filter(t => t.treatmentKey !== treatment.treatmentKey);
      if (!treatment.isEligible) {
        return withoutCurrent;
      }
      return [...withoutCurrent, treatment];
    });
  }, []);
  const value = useMemo(() => ({
    treatments,
    isLoading,
    hasFetched: !isLoading,
    eligibleTreatments,
    registerEligibility
  }), [treatments, isLoading, eligibleTreatments, registerEligibility]);
  return /*#__PURE__*/_jsx(ExperimentContext.Provider, {
    value: value,
    children: children
  });
};
export const useExperimentContext = () => {
  const context = useContext(ExperimentContext);
  if (!context) {
    throw new Error('useExperimentContext must be used within an ExperimentProvider');
  }
  return context;
};

/**
 * Test-only provider that supplies static defaults without calling laboratoryClient.resolve().
 */
export const TestExperimentProvider = ({
  children
}) => {
  const value = useMemo(() => ({
    treatments: {},
    isLoading: false,
    hasFetched: true,
    eligibleTreatments: [],
    registerEligibility: () => {}
  }), []);
  return /*#__PURE__*/_jsx(ExperimentContext.Provider, {
    value: value,
    children: children
  });
};
export const useEligiblePublicTreatments = () => {
  const {
    eligibleTreatments
  } = useExperimentContext();
  return useMemo(() => eligibleTreatments.filter(t => t.isPublic), [eligibleTreatments]);
};
export const useEligibleInAppTreatments = () => {
  const {
    eligibleTreatments
  } = useExperimentContext();
  return useMemo(() => eligibleTreatments.filter(t => t.isInApp), [eligibleTreatments]);
};